import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceVerifyJob } from "./parseComplianceVerify";
import { COMPLIANCE_RESULTS_LIST_QUERY_KEY } from "./useComplianceResultsList";
import type { ComplianceVerifyJob } from "./types";

export const startComplianceVerification =
  async (): Promise<ComplianceVerifyJob | null> => {
    const response = await createRegulatorPortalInstance().post(
      API_ROUTES.REGULATOR_COMPLIANCE_VERIFY,
      {},
    );
    return parseComplianceVerifyJob(response.data);
  };

export const useStartComplianceVerification = (): UseMutationResult<
  ComplianceVerifyJob | null,
  Error,
  void
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "verify"],
    mutationFn: startComplianceVerification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: COMPLIANCE_RESULTS_LIST_QUERY_KEY,
      });
    },
  });
};
